import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { Row, Col, Button /* Dropdown */ } from 'react-bootstrap';
import { checkTableAuth } from '../../components/common/access-auth';
import { commonRenderInput, dateFormatter } from '../../components/common/access-form';
import { withRouter } from 'react-router-dom';
import { verifyForm, verifyAccount, verifyTelNumber, maxLength32, maxLength256 /*, verifyTimezone */ } from '../../components/common/access-form-validation';
import { popupModalConfirm, openPickModal, closeModal, openModalAlert, openModalTip } from '../../actions/index';
import Loading from '../../components/common/Loading';
import _ from 'lodash';
import timezones from '../common/timezones';
import TimezoneSelect from 'react-timezone-select';
import { doSelectSite, loadSiteSummary, doSaveOrganizationData, SAVE_ORGANIZATION_DATA_SUCCESS, SAVE_ORGANIZATION_DATA_FAIL } from '../../actions/site/index';
import { doActivePage } from '../../actions/menu/index';
import { doChangeTimeZoneId } from '../../actions/login';

let addEnable = false;

class SiteForm extends Component {

    constructor(props) {
        super(props);
        const { detail, modalMessage } = this.props
        if (detail) {
            this.state = {
                id: detail.id,
                name: detail.name,
                address: detail.address,
                tel: detail.tel,
                email: detail.email,
                country: detail.country,
                state: detail.state,
                city: detail.city,
                timezone: detail.timezone,
                selectedTimezone: detail.timezone ? detail.timezone : {},
                setSelectedTimezone: {}
            }
        } else if (modalMessage === 'add') {
            this.state = {
                selectedTimezone: {},
                setSelectedTimezone: {}
            }
        }
    }

    saveOrgDetailData = (values) => {
        const { verifyFormPass, modalMessage, popupModalConfirm, authToken, accountRole, roleTableAuth, doSaveOrganizationData, openModalAlert, siteOptions } = this.props;
        
        if (checkTableAuth('model_organization', accountRole, roleTableAuth)) {
            if (verifyFormPass) {
                let verifyEmailMsg = verifyAccount(values.email), verifyTelMsg = verifyTelNumber(values.tel);
                if (verifyEmailMsg) {
                    openModalAlert(verifyEmailMsg);
                }
                else if (verifyTelMsg) {
                    openModalAlert(verifyTelMsg);
                }
                else {
                    let saveData = _.omit(values, ['readyToAddPassword', 'createdDate', 'createdBy', 'lastUpdatedDate', 'lastUpdatedBy']);
                    popupModalConfirm('Confirm', 'icon-alert', 'Confirm to save change ?', 300, () => {
                        doSaveOrganizationData(saveData, modalMessage, authToken, siteOptions);
                    }, null, false);
                }
            }
            else {
                openModalAlert('Some columns has empty, please input data');
            }
        } else {
            openModalAlert("Sorry you don't have permission to change config.");
        }

    }

    checkEnabled = (e) => {
        const { formValues, change, isReadonly } = this.props;
        if (!isReadonly && formValues) {
            const doCheck = formValues.enabled !== 1 ? 1 : 0;
            change('enabled', doCheck);
        }
        else if (!isReadonly && !formValues) {
            addEnable = addEnable === true ? false : true
            change('enabled', addEnable);
        }
    }

    timezonehandleChange = (newValue) => {
        this.props.change('timezone', newValue.value);
        console.log(newValue.label)
        this.setState({ selectedTimezone: newValue });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { siteStatus, closeModal, openModalTip, openModalAlert, loadSiteSummary, authToken, errMsg } = this.props;
        // const { refTable } = this.state;
        // let saveData = _.omit(values, ['createdDate','createdBy','lastUpdatedDate','lastUpdatedBy'])
        if (prevProps.siteStatus !== siteStatus) {
            if (siteStatus === SAVE_ORGANIZATION_DATA_SUCCESS) {
                openModalTip('Saved Successfully');
                closeModal(null);
                loadSiteSummary(authToken);
            } else if (siteStatus === SAVE_ORGANIZATION_DATA_FAIL) {
                if (errMsg) {
                    openModalAlert(errMsg);
                } else {
                    openModalAlert("Server no response.");
                }
            }
        }
    }

    goToSetting = () => {
        const { history , detail, doSelectSite, closeModal, doChangeTimeZoneId /*, doActivePage */ } = this.props;
        doChangeTimeZoneId(detail.timezone)
        closeModal(null);
        doSelectSite(detail.id);
        // doActivePage('/settings/siteAndGroup');
        history.push(window.CONFIG.WEB_ROOT + '/settings/siteAndGroup');
    }

    renderViewForm = () => {
        const { handleSubmit, initialValues } = this.props;

        return (
            <div className='area-form form-custom'>
                <form onSubmit={handleSubmit(this.saveOrgDetailData)}>
                    <div>

                        <div className='area-body'>
                            <Row>
                                <Col className='area-form-label'>
                                    Site Name
                                </Col>
                                <Col className='area-form-field-info'>
                                    {initialValues['name']}

                                </Col>
                            </Row>
                            <div className='line-content'></div>
                            <Row>
                                <Col className='area-form-label'>
                                    Description
                                </Col>
                                <Col className='area-form-field-info'>
                                    {initialValues['description']}

                                </Col>
                            </Row>
                            <div className='line-content'></div>
                            <Row>
                                <Col className='area-form-label'>
                                    Devices
                                </Col>
                                <Col className='area-form-field'>
                                    {initialValues['devices']}

                                </Col>
                            </Row>
                            <div className='line-content'></div>
                            <Row>
                                <Col className='area-form-label'>
                                    Clients
                                </Col>
                                <Col className='area-form-field'>
                                    {initialValues['clients']}

                                </Col>
                            </Row>
                            <div className='line-content'></div>
                            <Row>
                                <Col className='area-form-label'>
                                    Email
                                </Col>
                                <Col className='area-form-field'>
                                    {initialValues['email']}

                                </Col>
                            </Row>
                            <div className='line-content'></div>
                            <Row>
                                <Col className='area-form-label'>
                                    Country
                                </Col>
                                <Col className='area-form-field'>
                                    {initialValues['country']}

                                </Col>
                            </Row>
                            <div className='line-content'></div>
                            <Row>
                                <Col className='area-form-label'>
                                    State
                                </Col>
                                <Col className='area-form-field'>
                                    {initialValues['state']}

                                </Col>
                            </Row>
                            <div className='line-content'></div>
                            <Row>
                                <Col className='area-form-label'>
                                    City
                                </Col>
                                <Col className='area-form-field'>
                                    {initialValues['city']}

                                </Col>
                            </Row>
                            <div className='line-content'></div>
                            <Row>
                                <Col className='area-form-label'>
                                    Timezone
                                </Col>
                                <Col className='area-form-field'>
                                    {initialValues['timezone']}

                                </Col>
                            </Row>
                            <div className='line-content'></div>
                            <Row>
                                <Col className='area-form-label'>
                                    Address
                                </Col>
                                <Col className='area-form-field'>
                                    {initialValues['address']}

                                </Col>
                            </Row>
                            <div className='line-content'></div>
                            <Row>
                                <Col className='area-form-label'>
                                    Tel.
                                </Col>
                                <Col className='area-form-field'>
                                    {initialValues['tel']}

                                </Col>
                            </Row>
                            <div className='line-content'></div>
                            <Row>
                                <Col className='area-form-label'>
                                    Created Date
                                </Col>
                                <Col className='area-form-field'>
                                    {initialValues['createdDate']}

                                </Col>
                            </Row>
                            <div className='line-content'></div>
                            <Row>
                                <Col className='area-form-label'>
                                    Created By
                                </Col>
                                <Col className='area-form-field'>
                                    {initialValues['createdBy']}

                                </Col>
                            </Row>
                            <div className='line-content'></div>
                            <Row>
                                <Col className='area-form-label'>
                                    Last Updated Date
                                </Col>
                                <Col className='area-form-field'>
                                    {initialValues['lastUpdatedDate']}

                                </Col>
                            </Row>
                            <div className='line-content'></div>
                            <Row>
                                <Col className='area-form-label'>
                                    Last Updated By
                                </Col>
                                <Col className='area-form-field'>
                                    {initialValues['lastUpdatedBy']}

                                </Col>
                            </Row>
                            {/* <div className='line-content'></div> */}
                            {/* <Row style={{display: isSuperAdmin ? '' : 'none'}}>
                                <Col className='area-form-label'>
                                    Password for ready to add device  
                                </Col>
                                <Col className='area-form-field'>
                                    {initialValues['readyToAddPassword']}
                                </Col>
                            </Row> */}

                        </div>
                    </div>
                    <hr />

                    {/* <Row className={'area-btns'}>
                        <Col className='area-btn-redirect'>
                            <Button variant="primary" size="lg" onClick={this.goToSetting}>Go to Site and Group Settings</Button>
                        </Col>
                    </Row> */}

                </form>
            </div>
        );
    }

    renderEditForm = () => {
        const { handleSubmit, isReadonly, verifyFormPass, closeModal, readOnly } = this.props;
        const { selectedTimezone } = this.state;

        return (
            <div className='area-form form-custom'>
                <form id="add-site-form" onSubmit={handleSubmit(this.saveOrgDetailData)}>
                    <div className='area-body'>
                        <Row>
                            <Col sm={12} className='area-form-label'>
                                {readOnly ? null : <label style={{ color: 'red' }}>*</label>}&nbsp;
                                Site Name
                            </Col>
                            <Col sm={12} >
                                <div className='area-form-field'>
                                    <Field id="add-site-form-name" name="name" type="text" component={commonRenderInput} placeholder="Please input site name" validate={maxLength32} disabled={isReadonly} />
                                </div>
                            </Col>
                            <Col sm={12}>
                                <div className='area-form-label'>
                                    <label>Email </label>
                                </div>
                            </Col>
                            <Col sm={12}>
                                <div className='area-form-field'>
                                    <Field id="add-site-form-email" name="email" type="text" component={commonRenderInput} placeholder="Please input email address" disabled={isReadonly} validate={verifyAccount} />
                                </div>
                            </Col>
                            <Col sm={12}>
                                <Row className='area-inside-row'>
                                    <Col sm={4}>
                                        <div className='area-form-label'>
                                            <label>Country </label>
                                        </div>
                                    </Col>
                                    <Col sm={4}>
                                        <div className='area-form-label'>
                                            <label>State </label>
                                        </div>
                                    </Col>
                                    <Col sm={4}>
                                        <div className='area-form-label'>
                                            <label>City </label>
                                        </div>
                                    </Col>
                                    <Col sm={4}>
                                        <div className='area-form-field'>
                                            <Field id="add-site-form-country" name="country" type="text" component={commonRenderInput} placeholder="Please input country" disabled={isReadonly} />
                                        </div>
                                    </Col>
                                    <Col sm={4}>
                                        <div className='area-form-field'>
                                            <Field id="add-site-form-state" name="state" type="text" component={commonRenderInput} placeholder="Please input state" disabled={isReadonly} />
                                        </div>
                                    </Col>
                                    <Col sm={4}>
                                        <div className='area-form-field'>
                                            <Field id="add-site-form-city" name="city" type="text" component={commonRenderInput} placeholder="Please input city" disabled={isReadonly} />
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col sm={12}>
                                <div className='area-form-label'>
                                    {readOnly ? null : <label style={{ color: 'red' }}>*</label>}&nbsp;
                                    <label>Timezone </label>
                                </div>
                            </Col>
                            <Col sm={12}>
                                <div className='area-form-field-timezone'>
                                    <TimezoneSelect
                                        id="add-site-form-timezone"
                                        value={selectedTimezone}
                                        onChange={this.timezonehandleChange}
                                        timezones={timezones}
                                    />
                                </div>
                            </Col>
                            <Col sm={12}>
                                <div className='area-form-label'>
                                    <label>Address </label>
                                </div>
                            </Col>
                            <Col sm={12}>
                                <div className='area-form-field'>
                                    <Field id="add-site-form-address" name="address" type="text" component={commonRenderInput} placeholder="Please input address" disabled={isReadonly} />
                                </div>
                            </Col>
                            <Col sm={12}>
                                <div className='area-form-label'>
                                    <label>Tel. </label>
                                </div>
                            </Col>
                            <Col sm={12}>
                                <div className='area-form-field'>
                                    <Field id="add-site-form-tel" name="tel" type="text" component={commonRenderInput} placeholder="Please input telephone number" disabled={isReadonly} validate={verifyTelNumber} />
                                </div>
                            </Col>
                            <Col sm={12}>
                                <div className='area-form-label'>
                                    {/* {readOnly ? null : <label style={{ color: 'red' }}>*</label>}&nbsp; */}
                                    <label>Description </label>
                                </div>
                            </Col>
                            <Col sm={12}>
                                <div className='area-form-field'>
                                    <Field id="add-site-form-description" name="description" type="text" component={commonRenderInput} placeholder="Please input description" validate={maxLength256} disabled={isReadonly} />
                                </div>
                            </Col>
                            <Col sm={12}>
                                <Row className={'area-btns'}>
                                    <Col className='area-btn-cancel'>
                                        <Button id="add-site-form-cancel" type="" variant="primary" size="lg" block onClick={() => closeModal(null)}>Cancel</Button>
                                    </Col>
                                    <Col className='area-btn-save'>
                                        <Button id="add-site-form-save" type="submit" variant="primary" size="lg" disabled={!verifyFormPass} block>Save</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </form>
            </div>
        )
    }

    render() {
        const { detail, modalMessage, initialValues } = this.props;

        if (detail && modalMessage === 'view' && initialValues) {
            return this.renderViewForm();
        } else if (modalMessage === 'add' || modalMessage === 'upd') {
            return this.renderEditForm();
        } else {
            return (<Loading loading={true}></Loading>);
        }
    }
}

const getverifyField = (modalMessage) => {
    let verifyFields = null;
    if (modalMessage === 'upd') verifyFields = ['name', 'timezone'];
    if (modalMessage === 'add') verifyFields = ['name', 'timezone'];
    return verifyFields;
}

const mapStateToProps = (state, ownProps) => {
    const timeZoneID = state.loginReducers.timeZoneID;
    const modalMessage = state.commonReducers.modalMessage;
    const modelOrgDetail = modalMessage === 'add' ? null : state.modelReducers.modelOrgDetail
    const verifyFormPass = verifyForm(state.form['SiteForm'], getverifyField(modalMessage));
    const isReadonly = modalMessage === 'view';
    const isAdd = modalMessage === 'add';

    let ret = {
        authToken: state.loginReducers.authToken,
        accountInfo: state.loginReducers.accountInfo,
        detail: modelOrgDetail,
        readOnly: modalMessage === 'view' ? true : false,
        accountRole: state.loginReducers.accountRole,
        roleTableAuth: state.loginReducers.roleTableAuth,
        status: state.settingsReducers.status,
        siteStatus: state.siteReducers.status,
        errMsg: state.siteReducers.errMsg,
        modalPick: state.commonReducers.modalPick,
        siteOptions: state.siteReducers.siteOptions,
        selectOrg: state.siteReducers.selectSite,
        timeZoneID: timeZoneID,
        modalMessage: modalMessage,
        isReadonly: isReadonly,
        isAdd: isAdd,
        verifyFormPass: verifyFormPass,
        formValues: getFormValues('SiteForm')(state)
    }

    if (modelOrgDetail) {
        let initialValues = {};
        initialValues['id'] = modelOrgDetail['id'];
        initialValues['name'] = modelOrgDetail['name'];
        initialValues['description'] = modelOrgDetail['description'];
        initialValues['devices'] = modelOrgDetail['devices'];
        initialValues['clients'] = modelOrgDetail['clients'];
        initialValues['email'] = modelOrgDetail['email'];
        initialValues['country'] = modelOrgDetail['country'];
        initialValues['state'] = modelOrgDetail['state'];
        initialValues['city'] = modelOrgDetail['city'];
        initialValues['timezone'] = modelOrgDetail['timezone'];
        initialValues['address'] = modelOrgDetail['address'];
        initialValues['tel'] = modelOrgDetail['tel'];
        initialValues['createdDate'] = dateFormatter(modelOrgDetail['createdDate'], timeZoneID);
        initialValues['createdBy'] = modelOrgDetail['createdBy'];
        initialValues['lastUpdatedDate'] = dateFormatter(modelOrgDetail['lastUpdatedDate'], timeZoneID);
        initialValues['lastUpdatedBy'] = modelOrgDetail['lastUpdatedBy'];
        initialValues['readyToAddPassword'] = modelOrgDetail['readyToAddPassword'];
        ret['initialValues'] = initialValues;

    }

    return ret;

}

SiteForm = reduxForm({
    form: 'SiteForm',  // a unique identifier for this form
})(SiteForm)

export default withRouter(connect(
    mapStateToProps,
    { openPickModal, popupModalConfirm, closeModal, doSaveOrganizationData, openModalAlert, openModalTip, doSelectSite, doActivePage, doChangeTimeZoneId, loadSiteSummary }
)(SiteForm))